<script setup lang="ts">

</script>

<template>
    <aeg-icon icon="pi pi-map-marker" />
</template>

<style scoped lang="scss">

</style>
